import myLocalStorage from './../config/myLocalStorage'
import store from '@/store/store'
import axios from 'axios'
import instance from '../config/axios'
// 初始化权限清单列表
export function hasPermission(str) {
  let stime = Date.now()
  let scopes = store.state.scopes
  if (!scopes || scopes.length === 0) {
    // window.btoa 编码
    let codeList = myLocalStorage.getData('dydnz_access_token').split('.')
    if (codeList !== '' && codeList.length > 1) {
      let listCode = JSON.parse(window.atob(codeList[1]))
      scopes = listCode.scopes
      store.commit('setScopes', scopes)
    }
    console.log('scopes is null init ' + str, Date.now() - stime)
  } else {
    // console.log('local scopes ' + str)
  }
  // console.log('time init ', Date.now() - stime)
  if (scopes.length > 0 && scopes.indexOf(str) !== -1) {
    return true
  } else {
    console.log('has not ' + str)
    return false
  }
}
export function getNewTime() {
  const dt = new Date()
  var year = dt.getFullYear() // 年
  var month = dt.getMonth() + 1 // 月
  var date = dt.getDate() // 日
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  var str = year + '-' + month + '-' + date
  return str
}

// 格式化时间（年月日）
export function getTime(dt) {
  var year = dt.getFullYear() // 年
  var month = dt.getMonth() + 1 // 月
  var date = dt.getDate() // 日
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  var str = year + '-' + month + '-' + date
  return str
}

// 格式化时间（年月日时分）
export function getTimeMinute(dt) {
  var year = dt.getFullYear() // 年
  var month = dt.getMonth() + 1 // 月
  var date = dt.getDate() // 日
  var hours = dt.getHours() // 时
  var minutes = dt.getMinutes() // 分
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  var str = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes
  return str
}
// 格式化时间（年月日时分）
export function getTimeAll(dt) {
  var year = dt.getFullYear() // 年
  var month = dt.getMonth() + 1 // 月
  var date = dt.getDate() // 日
  var hours = dt.getHours() // 时
  var minutes = dt.getMinutes() // 分
  var seconds = dt.getSeconds() // 秒
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  seconds = seconds < 10 ? '0' + seconds : seconds
  var str = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds
  return str
}

// 获取日期本周/上n周
export function handleTimeWeek(num) { // 0本周 num>0 上num周
  var dt = new Date()
  var year = dt.getFullYear() // 年
  var month = dt.getMonth() + 1 // 月
  var date = dt.getDate() // 日
  var week = dt.getDay() === 0 ? 7 : dt.getDay()// 周几
  // 开始时间
  var start = ''
  var startYear = year
  var startMonth = month
  var startDay = date - week + 1
  if (num !== 0) {
    // 上n周，开始日期-7*n
    startDay -= 7 * num
  }
  if (startDay < 1) {
    // 退回上个月
    startMonth = month - 1
    if (startMonth < 1) {
      // 退回上一年
      startYear = year - 1
      startMonth = 12
    }
    // 当前月份天数
    let thisDayNum = new Date(startYear, startMonth, 0).getDate()
    // 当前月份天数+应该在上个月的天数=倒数n天
    startDay = thisDayNum + startDay
  }
  start = startYear + '-' + startMonth + '-' + startDay
  // 结束时间
  var end = ''
  var endYear = startYear
  var endMonth = startMonth
  var endDay = startDay + 6
  // 当前月份天数
  var dayNum = new Date(startYear, startMonth, 0).getDate()
  if (endDay > dayNum) {
    // 加到下个月
    endMonth = startMonth + 1
    if (endMonth > 12) {
      // 加到下一年
      endYear = year + 1
      endMonth = 1
    }
    // 超出日期-当前月份天数=下月日期
    endDay = endDay - dayNum
  }
  end = endYear + '-' + endMonth + '-' + endDay
  return [start, end]
}

// 获取日期本月/上n月
export function handleTimeMonth(num) {
  var dt = new Date()
  var year = dt.getFullYear() // 年
  var month = dt.getMonth() + 1 // 月
  if (num !== 0) {
    month = month - num > 0 ? month - num : 12 + (month - num)
  }
  // 当前月份天数
  let dayNum = new Date(year, month, 0).getDate()
  let start = year + '-' + month + '-1'
  let end = year + '-' + month + '-' + dayNum
  return [start, end]
}

// handleTime是获取日期区间 前n天
export function handleTime(time, num) {
  let date
  if (num !== undefined) {
    date = new Date(time.setDate(time.getDate() - num))
  } else {
    date = new Date(time.setDate(time.getDate()))
  }
  let year = date.getFullYear()
  let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
  return `${year}-${month}-${day}`
}

// handleTimeOld是获取日期区间【0】前7天
export function handleTimeOld(time) {
  let date = new Date(time.setDate(time.getDate() - 7))
  let year = date.getFullYear()
  let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
  return `${year}-${month}-${day}`
}

// handleTimeNew是获取日期区间【1】前1天
export function handleTimeNew(time) {
  let date = new Date(time.setDate(time.getDate() - 1))
  let year = date.getFullYear()
  let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
  return `${year}-${month}-${day}`
}

export function handleTimeMonthsAgo(time, agoMonths, contains) {
  // contains 为true时指包含当前月
  let date = new Date(time.setDate(time.getDate()))
  let year = date.getMonth() < 1 ? date.getFullYear() - 1 : date.getFullYear()
  let month
  if (agoMonths === 2 && contains) {
    month = date.getMonth() < 1 ? 12 - date.getMonth() : date.getMonth()
  } else {
    month = date.getMonth() < 1 ? 12 - date.getMonth() : date.getMonth() - (agoMonths - 1)
  }
  // let day = date.getDate() > 11 ? date.getDate() : ('0' + date.getDate())
  return `${year}-${month}-1`
}

// 时间戳转换 年-月-日 时:分:秒
export function getLocalTime(nS) {
  let year = nS.getFullYear() // 取得4位数的年份
  let month = nS.getMonth() + 1 // 取得日期中的月份，其中0表示1月，11表示12月
  let date = nS.getDate() // 返回日期月份中的天数（1到31）
  let hour = nS.getHours() // 返回日期中的小时数（0到23）
  let minute = nS.getMinutes() // 返回日期中的分钟数（0到59）
  let second = nS.getSeconds() // 返回日期中的秒数（0到59）
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  hour = hour < 10 ? '0' + hour : hour
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
}

// 时间戳转换 年_月_日_时:分:秒
export function getLocalTime2(nS) {
  let year = nS.getFullYear() // 取得4位数的年份
  let month = nS.getMonth() + 1 // 取得日期中的月份，其中0表示1月，11表示12月
  let date = nS.getDate() // 返回日期月份中的天数（1到31）
  let hour = nS.getHours() // 返回日期中的小时数（0到23）
  let minute = nS.getMinutes() // 返回日期中的分钟数（0到59）
  let second = nS.getSeconds() // 返回日期中的秒数（0到59）
  month = month < 10 ? '0' + month : month
  date = date < 10 ? '0' + date : date
  hour = hour < 10 ? '0' + hour : hour
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return year + '_' + month + '_' + date + '_' + hour + ':' + minute + ':' + second
}

// 分割字符串
export function splitString(str, code) {
  // code 用来分隔的符号
  if (code === '') {
    code = /[ ]+/
  }
  let arr = str.split(code) // 以分隔符分开
  return arr
}

// 获取字节数
export function getChars(str) {
  var i = 0
  var c = 0.0
  var unicode = 0
  var len = 0
  if (str === '' || str == null) {
    return 0
  }

  len = str.length
  for (i = 0; i < len; i++) {
    unicode = str.charCodeAt(i)
    if (unicode < 127) {
      // 判断是单字符还是双字符
      c += 1
    } else {
      // chinese
      c += 2
    }
  }
  return c
}

// 截取小数点后n位
export function strSubstring(value, num) {
  if (value !== '' && value.indexOf('.') !== -1) {
    return value.substring(0, value.indexOf('.') + (num + 1))
  } else {
    return value
  }
}

// 排序
export function compar(array, key) {
  // return array.sort(function (a, b) {
  //   const x = a[key]
  //   const y = b[key]
  //   return x.localeCompare(y)
  // })
  return array.sort(function(a, b) {
    let x = a[key]
    let y = b[key]
    return x < y ? -1 : x > y ? 1 : 0
  })
}

export function getRandomInt(min, max) {
  // min = Math.ceil(min)
  // max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1) + min)
}
// 获取2个数之间的随机数,支持小数点
export function getRandomNumList(min, max, total) {
  let stringmax = String(max)
  let stringmin = String(min)

  let maxindex = stringmax.indexOf('.')
  let minindex = stringmin.indexOf('.')
  // 小数点后的数字
  let maxpointLength = 0
  let minpointLength = 0
  // 小数点前的数字
  let maxNum = parseFloat(max)
  let minNum = parseFloat(min)
  if (maxindex !== -1) {
    let mxstr = stringmax.substring(maxindex + 1)
    maxpointLength = String(mxstr).length
  }
  if (minindex !== -1) {
    let minpointNum = stringmin.substring(minindex + 1)
    minpointLength = String(minpointNum).length
  }
  let num = maxpointLength > minpointLength ? maxpointLength : minpointLength
  let pecent = 1
  for (let j = 0; j < num; j++) {
    pecent = pecent * 10
  }
  minNum = minNum * pecent
  maxNum = maxNum * pecent
  const arr = []
  for (let index = 0; index < total; index++) {
    let resultRandom = getRandomInt(minNum, maxNum)
    let result = resultRandom / pecent
    console.log('result ', result)
    arr.push(result)
  }
  console.log('arr', arr)
  return arr
}
export function splicing(list) {
  let same
  let i = -1
  let len = list.length
  let arr = []

  if (!len) return
  while (++i < len) {
    const item = list[i]
    if (item.check) {
      if (item.check !== Boolean(same)) {
        arr.push(...[',', item.begin, '~', item.end])
      } else if (arr.length) {
        arr.pop()
        arr.push(item.end)
      }
    }
    same = Boolean(item.check)
  }
  arr.shift()
  return arr.join('')
}
export function tranListToTreeData(list, rootValue) {
  var arr = []
  list.forEach(item => {
    if (item.pid === rootValue) {
      // 找到之后 就要去找 item 下面有没有子节点
      const children = tranListToTreeData(list, item.id)
      if (children.length) {
        // 如果children的长度大于0 说明找到了子节点
        item.children = children
      }
      arr.push(item) // 将内容加入到数组中
    }
  })
  return arr
}
export function industryToTreeData(list) {
  // var arr = JSON.parse(JSON.stringify(list))
  var arr = list
  let map = {} // 构建map
  arr.forEach(i => {
    map[i.industryId] = i // 构建以area_id为键 当前数据为值
  })
  let treeData = []
  arr.forEach(child => {
    const mapItem = map[child.fatherId] // 判断当前数据的parent_id是否存在map中
    if (mapItem) { // 存在则表示当前数据不是最顶层数据
      if (!mapItem.children) {
        mapItem.children = []
      }
      mapItem.children.push(child)
      // console.log('mapItem', mapItem)
      // 注意: 这里的map中的数据是引用了arr的它的指向还是arr，当mapItem改变时arr也会改变,踩坑点
      // (mapItem.children || (mapItem.children = [])).push(child) // 这里判断mapItem中是否存在children, 存在则插入当前数据, 不存在则赋值children为[]然后再插入当前数据
    } else { // 不存在则是组顶层数据
      treeData.push(child)
    }
  })
  return treeData
}
/**
 * 权限list数据转换
 * @param {*} arr 数组
 * @param {*} id 数组中子级ID名称 本地测试数据industryId
 * @param {*} fatherId 父级ID名
 * @returns 处理之后的数据
 */
export function tranArrToTreeData(arr) {
  let map = {} // 构建map
  arr.forEach(i => {
    map[i.id] = i
  })
  let treeData = []
  arr.forEach(child => {
    if (child.pitchOn) {
      child.isChecked = child.pitchOn === 1
    } else {
      child.isChecked = false
    }
    const mapItem = map[child.pid] // 判断当前数据的parent_id是否存在map中
    if (mapItem) { // 存在则表示当前数据不是最顶层数据
      // console.log('mapItem', mapItem)
      if ((mapItem.authorityLevel === 2 && mapItem.takeEffect === 1) || mapItem.authorityName === '首页' || (mapItem.authorityLevel === 3)) {
        (mapItem.menuFeatures || (mapItem.menuFeatures = [])).push(child)
      } else if (mapItem.takeEffect === 2 && mapItem.authorityLevel === 2) {
        (mapItem.children || (mapItem.children = [])).push(child)
      } else {
        // 注意: 这里的map中的数据是引用了arr的它的指向还是arr，当mapItem改变时arr也会改变,踩坑点
        (mapItem.children || (mapItem.children = [])).push(child) // 这里判断mapItem中是否存在children, 存在则插入当前数据, 不存在则赋值children为[]然后再插入当前数据
      }
    } else { // 不存在则是组顶层数据
      treeData.push(child)
    }
  })
  return treeData
}

// 格式化数字（字符串等
export function formatIntNumber(count) {
  if (count !== null && isNaN(parseInt(count)) === false) {
    return parseInt(count)
  } else {
    return 0
  }
}

// 获取日期
export function getData(type, date) {
  // type：star end
  let timeStar = ''
  let timeEnd = ''
  let dateReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/
  // console.log(date)
  if (date !== [] && date !== undefined && date !== null) {
    if (!dateReg.test(date[0])) {
      date = [getTime(date[0]), getTime(date[1])]
    }
    timeStar = date[0]
    timeEnd = date[1]
  }
  if (type === 'star') {
    return timeStar
  } else if (type === 'end') {
    return timeEnd
  }
}

// get转参数
export function getParamUrl (param) {
  if (typeof param !== 'object') return ''
  let paramUrl = ''
  const attrs = Object.keys(param)
  let count = 0
  console.log(attrs)
  attrs.forEach(key => {
    if (param[key]) {
      paramUrl += (count > 0 ? '&' : '') + key + '=' + param[key]
      count++
    }
  })
  // console.log(paramUrl)
  return paramUrl
}

export function downloadFile (url, param, fileName) {
  getParamUrl(param)
  axios.get(instance.defaults.baseURL + url + '?' + getParamUrl(param), {
    // params: getParamUrl(param),
    responseType: 'blob',
    headers: { Authorization: 'Bearer ' + myLocalStorage.getData('dydnz_access_token') }
  }).then((response) => {
    // console.log(response)
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName + getTimeAll(new Date()) + '.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
  }).catch(err => {
    console.log(err)
  })
}



// WEBPACK FOOTER //
// ./src/components/public.js